<template>
  <ThePage :title="i18n(translations.pageTitle)">
    <template #pageTitle>
      {{ i18n(translations.title, { sellerName: companyName }) }}
    </template>

    <template #pageContent>
      <WelcomeSellerModal />
      <div class="body-1 mb-32">
        {{ i18n(translations.subtitle) }}
      </div>
      <OnboardingSteps />
    </template>
  </ThePage>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { useSellerInfoStore } from '~/scopes/auth/stores/sellerInfoStore'

import translations from './Home.translations'
import OnboardingSteps from './components/OnboardingSteps/OnboardingSteps.vue'
import WelcomeSellerModal from './components/WelcomeSellerModal/WelcomeSellerModal.vue'

const { companyName } = useSellerInfoStore()

const i18n = useI18n()
</script>
